const MAX_FILE_SIZE=10 * 1024 * 1024;
const MAX_DIMENSION=1400;

export async function prepareBusinessImage(file) {
  if (!file?.type.startsWith('image/')) {
    throw new Error('Choose an image file.');
  }
  if (file.size > MAX_FILE_SIZE) {
    throw new Error('Choose an image smaller than 10 MB.');
  }
  if (typeof window.createImageBitmap !== 'function') {
    throw new Error('Image uploads are not supported in this browser.');
  }

  const bitmap=await window.createImageBitmap(file);
  try {
    const scale=Math.min(1,MAX_DIMENSION / Math.max(bitmap.width,bitmap.height));
    const canvas=document.createElement('canvas');
    canvas.width=Math.max(1,Math.round(bitmap.width * scale));
    canvas.height=Math.max(1,Math.round(bitmap.height * scale));
    const context=canvas.getContext('2d');
    if (!context) throw new Error('Could not process this image.');

    context.fillStyle='#ffffff';
    context.fillRect(0,0,canvas.width,canvas.height);
    context.drawImage(bitmap,0,0,canvas.width,canvas.height);
    return canvas.toDataURL('image/jpeg',0.82);
  } finally {
    bitmap.close();
  }
}